import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=4c337184&scoped=true"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"
import style0 from "./ThankYou.vue?vue&type=style&index=0&id=4c337184&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c337184",
  null
  
)

export default component.exports